import Summary from './containers/Summary';

export default Summary;
